/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./nullState.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.nullState', deps)

  .directive('blNullState', () => ({
    restrict: 'E',
    scope: {
      icon: '@',
      header: '@',
      body: '@',
      action: '=',
      actionLabel: '@',
    },
    bindToController: true,
    template: require('./nullState.html'),
    controller() {},
    controllerAs: 'vm',
    link(scope, elem, attrs) {
      return elem.addClass('bl-null-state');
    },
  }));
